import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Message} from "../../models/message";
import {Role} from "../../models/role";
import {RoleStatusMessage} from "../../models/status-message";

@Directive()
@Injectable()
export class RoleStatusService {

  public serviceId: string;
  public statusMessages: RoleStatusMessage[];
  public allRoles: any[];
  public role: Role;
  public messageType: string;
  public roleStatusMessage: RoleStatusMessage;
  public message: Message;
  public statusType: string;
  public topLayer: string;

  @Output() public initStatusMessageEdit: EventEmitter<any> = new EventEmitter();
  @Output() public initMessageEdit: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();
  @Output() public updateList: EventEmitter<any> = new EventEmitter();

  public initData() {
    this.change.emit({
      serviceId: this.serviceId,
      statusMessages: this.statusMessages,
      allRoles: this.allRoles,
      role: this.role,
      messageType: this.messageType,
      statusType: this.statusType,
      topLayer: this.topLayer,
    });
    this.resetData();
  }

  public initStatusMessageEditData() {
    this.initStatusMessageEdit.emit({
      roleStatusMessage: this.roleStatusMessage,
      messageType: this.messageType,
      statusType: this.statusType,
    });
    this.resetData();
  }

  public initMessageEditData() {
    this.initMessageEdit.emit({
      message: this.message,
      messageType: this.messageType,
      statusType: this.statusType,
    });
    this.resetData();
  }

  public updateData() {
    this.update.emit({
      update: true,
      roleStatusMessage: this.roleStatusMessage,
      statusType: this.statusType,
    });
  }
  public updateListData() {
    this.updateList.emit({
      update: true,
    });
  }

  public resetData() {
    this.serviceId = null;
    this.statusMessages = [];
    this.allRoles = [];
    this.role = null;
    this.messageType = null;
    this.roleStatusMessage = null;
    this.statusType = null;
    this.topLayer = null;
  }

}
